var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-card",
        { staticClass: "auth-card relative-position" },
        [
          _c(
            "q-card-main",
            [
              _c("check-mark"),
              _c("h4", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("team_deleted_confirmation_title")))
              ]),
              _c("p", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("team_deleted_confirmation_body")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }